import * as angular from 'angular';
import * as moment from 'moment';
import { SupportStatuses } from '../../../../ng2/shared/constants/support-statuses.constant';
import nvSharedServicesModule from '../nv.shared.services.module';

export class SupportScheduleService {
  static $inject = [];

  constructor() {
    //
  }

  dateIsBefore(support, date): boolean {
    const exactStart = moment(support.schedule.startsOn + ' ' + support.schedule.startTime, 'YYYY-MM-DD');
    return date.isBefore(exactStart);
  }

  dateIsBetween(support, date): boolean {
    return date.isBetween(support.schedule.startsOn, support.schedule.endsOn, null, '[]');
  }

  dateIsAfter(support, date): boolean {
    const exactEnd = moment(support.schedule.endsOn + ' ' + support.schedule.endTime, 'YYYY-MM-DD');
    return date.isAfter(exactEnd);
  }

  getSupportStatusBasedOnSchedule(support) {
    // backend status is deleted, so return removed
    const backendStatus = support.status;
    if (backendStatus === SupportStatuses.backend.DELETED) {
      return SupportStatuses.frontend.REMOVED;
    }

    // backend status is active, so return 'not started', 'completed', or 'current' based on date
    const now = moment();
    if (this.dateIsBefore(support, now)) {
      return SupportStatuses.frontend.NOT_STARTED;
    } else if (this.dateIsBetween(support, now)) {
      return SupportStatuses.frontend.IN_PROGRESS;
    } else if (this.dateIsAfter(support, now)) {
      return SupportStatuses.frontend.COMPLETED;
    }
  }

  /**
   *
   * @param support
   * @returns {number}
   */
  getSupportOrderBasedOnCurrentState(support) {
    const supportStatus = this.getSupportStatusBasedOnSchedule(support);
    if (supportStatus === SupportStatuses.frontend.IN_PROGRESS) {
      return 0;
    } else if (supportStatus === SupportStatuses.frontend.NOT_STARTED) {
      return 1;
    } else if (supportStatus === SupportStatuses.frontend.COMPLETED) {
      return 2;
    } else if (supportStatus === SupportStatuses.frontend.REMOVED) {
      return 3;
    }
  }
}

angular.module(nvSharedServicesModule).service('SupportScheduleService', SupportScheduleService);
